import type { Region } from "@/lib/region";

type CoverageLogo = {
  src: string;
  alt: string;
  heightClass: string;
  regions: Region[];
};

// Per-logo heights tuned for similar visual area despite different aspect
// ratios. Use with `items-center` rows. The Irish insurers don't operate in
// the UK, so only Humm shows there.
export const COVERAGE_LOGOS: CoverageLogo[] = [
  { src: "/assets/logo/vhi.png", alt: "Vhi", heightClass: "h-5", regions: ["ie"] },
  { src: "/assets/logo/ilh.png", alt: "Irish Life Health", heightClass: "h-7", regions: ["ie"] },
  { src: "/assets/logo/laya.png", alt: "Laya Healthcare", heightClass: "h-6", regions: ["ie"] },
  { src: "/assets/logo/humm.png", alt: "Humm", heightClass: "h-4", regions: ["ie", "uk"] },
];

export function coverageLogosForRegion(region: Region) {
  return COVERAGE_LOGOS.filter((logo) => logo.regions.includes(region));
}
